var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.699 4.50102V3.39945C14.699 2.18507 13.7151 1.19989 12.4995 1.19989C11.2839 1.19989 10.2999 2.18507 10.2999 3.39945V4.50102",
    fill: "var(--gray-20)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97524 9.82537C5.97524 6.82183 8.40999 4.38828 11.4123 4.38828H13.5879C16.5914 4.38828 19.025 6.82303 19.025 9.82537V13.1817C19.025 13.8177 19.2782 14.4285 19.7282 14.8785L20.4974 15.6477C20.9473 16.0976 21.2005 16.7084 21.2005 17.3444C21.2005 18.5972 20.1854 19.6124 18.9326 19.6124H6.06764C4.81486 19.6124 3.79968 18.5972 3.79968 17.3444C3.79968 16.7084 4.05288 16.0976 4.50287 15.6477L5.27205 14.8785C5.72204 14.4285 5.97524 13.8177 5.97524 13.1817V9.82537Z",
    fill: "var(--gray-20)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75012 20.0505V19.6125L15.2508 19.6113V20.0493C15.2508 21.5685 14.0196 22.7996 12.5005 22.7996C10.9813 22.7996 9.75012 21.5685 9.75012 20.0505Z",
    fill: "var(--gray-20)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSolid);
export default __webpack_public_path__ + "static/media/bell-solid.775dcd848d4ebcdbf2abd40db1cbda46.svg";
export { ForwardRef as ReactComponent };